export default function () {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="96" height="27" viewBox="0 0 96 27" fill="none">
            <path d="M25.8635 20.0425H33.2015L27.3205 12.0869L22.2588 15.1698L25.8635 20.0425Z" fill="white" />
            <path d="M56.0273 16.5238H58.6616L62.1478 3.5166H59.5111L56.0273 16.5238Z" fill="white" />
            <path
                d="M48.3996 3.5166H45.6923L42.8918 14.003C42.5187 15.3945 43.3455 16.5238 44.737 16.5238H54.1495L54.8554 13.8946H45.6293L48.3996 3.5166Z"
                fill="white"
            />
            <path
                d="M74.0584 12.7124L67.4312 3.5166H67.3707H64.6634L61.1772 16.5238H63.8846L66.3499 7.32549L72.9744 16.5238H73.8819H75.7447L79.231 3.5166H76.5212L74.0584 12.7124Z"
                fill="white"
            />
            <path
                d="M95.4347 3.5166H91.031L82.9796 8.74469L84.3811 3.5166H81.7469L78.2607 16.5238H80.8949L82.2057 11.631L87.1187 16.5238H91.5225L85.1601 10.1866L95.4347 3.5166Z"
                fill="white"
            />
            <path d="M33.6758 11.3712H40.9533L41.6767 8.66895H34.4017L33.6758 11.3712Z" fill="white" />
            <path d="M18.3819 0H11.0464L17.4542 8.67146L22.1327 5.07179L18.3819 0Z" fill="white" />
            <path d="M39.922 0H30.7035L14.7622 12.2283H18.2535L0.635742 27L30.8144 8.66894H27.2854L39.922 0Z" fill="url(#paint0_linear_540_1463)" />
            <defs>
                <linearGradient id="paint0_linear_540_1463" x1="37.7491" y1="-1.72387e-07" x2="0.693718" y2="26.9723" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#EAC64C" />
                    <stop offset="0.554786" stopColor="#C09325" />
                    <stop offset="1" stopColor="#AF7D14" />
                </linearGradient>
            </defs>
        </svg>
    );
}
